/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NavigationRpc
 */

export const ConsentErrorTypename = 'com.hubspot.portals.platform.models.rpc.ConsentError';
export const NotificationErrorTypename = 'com.hubspot.portals.platform.models.rpc.NotificationError';
export const PortalAuthErrorTypename = 'com.hubspot.portals.platform.models.rpc.PortalAuthError';
export const SettingsErrorTypename = 'com.hubspot.portals.platform.models.rpc.SettingsError';
export const getNavigationManifestsRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NavigationRpc',
  rpcName: 'getNavigationManifests',
  auth: 'external',
  fingerprint: '92yA48uforZI6ZYLpXG-oUWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPortalNavigationRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NavigationRpc',
  rpcName: 'getPortalNavigation',
  auth: 'external',
  fingerprint: 'PrXECjWH3Qx4l2wCtjsuDUWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getNavigationMenuRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NavigationRpc',
  rpcName: 'getNavigationMenu',
  auth: 'external',
  fingerprint: 'fOEbr6yzpa-d9KLG3JsbUoxZFAQwBbvR',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};